export default {
  getReqID(state) {
    return state
  },
};